import React from "react";
import { RenderComponents } from "../../../hooks/components";

const ReusableBlock = ({ blok }) => {
   return <RenderComponents bloks={blok.block.content.body} />;
};

export default ReusableBlock;
